import { render } from "./LanguageSwitch.vue?vue&type=template&id=2df0a659"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=2df0a659&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__